@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 gap-2" novalidate>
    <app-form-number-input [form]="form" [max]="999" [min]="1" id="nummer" label="CHOP.NUMMER"></app-form-number-input>
    <app-form-text-input [form]="form" id="bezeichnung.De" label="GLOBAL.NAME_De"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.Fr" label="GLOBAL.NAME_Fr"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.It" label="GLOBAL.NAME_It"></app-form-text-input>
    <app-form-button-bar (onCancel)="cancel()" [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
}
